import isEqual from 'lodash/isEqual';
export const validateExportFields = ({ fields, compareFields, }) => {
    for (const field of fields) {
        const compareField = compareFields.find(({ headerName }) => field.headerName === headerName);
        if (!compareField) {
            return { error: 'does-not-exist', field: field.headerName, success: false };
        }
        if (!isEqual(compareField, field)) {
            return { error: 'mismatch', field: field.headerName, success: false };
        }
    }
    return { success: true };
};
